<div class="container">
  <div>
    <div class="row justify-content-center">
      <div class="provides-connectivity">
        <h2 class="provides-connectivity-title" data-test-id="provides-connectivity-description-text-1">
          {{'Provides_Connectivity_Description_Text_1' | translate }}</h2>
      </div>
    </div>
  </div>
</div>